// import React, { useState, useEffect, useRef } from 'react';
// import { db } from '../firebase';
// import { collection, addDoc } from 'firebase/firestore';
// import { sendApplicationConfirmationSMS } from '../services/smsService';
// import './ApplicationForm.css';

// const schools = [
//   "NEVŞEHİR - ÜRGÜP - ÜRGÜP ŞEHİT POLİS FEVZİ BAŞARAN ORTAOKULU",
//   "NEVŞEHİR - ÜRGÜP - Ürgüp Atatürk Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Şehit Ali Kayaca İmam Hatip Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Ortahisar İlkokulu",
//   "NEVŞEHİR - ÜRGÜP - Ortahisar Fatih Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Ortahisar Fatih İlkokulu",
//   "NEVŞEHİR - ÜRGÜP - Mustafapaşa Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Mustafa-Veli Halıcı İmam Hatip Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Mehmet Diker Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Mazı Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Hacı Ahmet Toksöz Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Başdere Ortaokulu",
//   "NEVŞEHİR - ÜRGÜP - Ali Baran Numanoğlu Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Yunus Emre İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Yavuz Sultan Selim Han Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Uçhisar Haydar Çankaya Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Sulusaray İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Sultan Alparslan Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Şehit Semih Turgut Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Özyayla Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Nevşehir Kavak 15 Temmuz Şehitleri İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Nevşehir Cumhuriyet Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Nevşehir Atatürk Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Nar Fikret Aktekin Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Mihriban Emin Günel Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Mehmet Gülen Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Mehmet Avlanmaz İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - MEHMET AKİF ERSOY İMAM HATİP ORTAOKULU",
//   "NEVŞEHİR - MERKEZ - Kaymaklı Atatürk Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Kavak Ortaokulu",
//   "NEVŞEHİR - MERKEZ - İstiklal Ortaokulu",
//   "NEVŞEHİR - MERKEZ - İcik Şehit Ali Türk Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Hacı Makbule Avlanmaz İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - H.Lütfi Pamukçu Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Göreme Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Göre Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Gazi Osman Paşa Ortaokulu",
//   "NEVŞEHİR - MERKEZ - GAZİ OSMAN PAŞA İMAM HATİP ORTAOKULU",
//   "NEVŞEHİR - MERKEZ - Gazi Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Damat İbrahim Paşa Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Çiftlik 100.Yıl Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Çat 15 Temmuz Diriliş Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Çardak İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Boğaz Şehit Murat Ateş Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Alacaşar Şehit İdris Aksöz İmam Hatip Ortaokulu",
//   "NEVŞEHİR - MERKEZ - 75.Yıl Ortaokulu",
//   "NEVŞEHİR - MERKEZ - 23 Nisan Ortaokulu",
//   "NEVŞEHİR - MERKEZ - Recep Tayyip Erdoğan Proje Ortaokulu",
//   "NEVŞEHİR - KOZAKLI - Kozaklı Mehmet Akif Ersoy Ortaokulu",
//   "NEVŞEHİR - KOZAKLI - Kozaklı Atatürk Ortaokulu",
//   "NEVŞEHİR - KOZAKLI - 75.Yıl Cumhuriyet Ortaokulu",
//   "NEVŞEHİR - HACIBEKTAŞ - Kızılağıl Ortaokulu",
//   "NEVŞEHİR - HACIBEKTAŞ - Karaburna Ortaokulu",
//   "NEVŞEHİR - HACIBEKTAŞ - Hacıbektaşveli Ortaokulu",
//   "NEVŞEHİR - HACIBEKTAŞ - Hacıbektaş Cumhuriyet Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Tuzköy Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Terlemez Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Karacaşar Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Gülşehir Ovaören Şehit Pilot Üsteğmen Yasin Boy Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Emmiler Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Alparslan Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - Abuşağı Ortaokulu",
//   "NEVŞEHİR - GÜLŞEHİR - 100.Yıl Şehit Şahin Kaya Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Yazıhüyük Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Suvermez Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Şehit Cihan ÇİFCİBAŞI Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Özlüce İmam Hatip Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Kuyulutatlar Erhan Karataş İmam Hatip Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Fatih Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Doğala Şehit Turan Damgacı Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Derinkuyu Şehit Selçuk Karabakla Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Derinkuyu Mehmet Akif Ersoy Ortaokulu",
//   "NEVŞEHİR - DERİNKUYU - Derinkuyu İmam Hatip Ortaokulu",
//   "NEVŞEHİR - AVANOS - Topaklı Ortaokulu",
//   "NEVŞEHİR - AVANOS - Şehit Polis Halil Gün Ortaokulu",
//   "NEVŞEHİR - AVANOS - Şehit Demet Sezen İmam Hatip Ortaokulu",
//   "NEVŞEHİR - AVANOS - Özkonak Cumhuriyet Ortaokulu",
//   "NEVŞEHİR - AVANOS - Mahmat Şehit Murat Koç Ortaokulu",
//   "NEVŞEHİR - AVANOS - Kalaba Mehmet Akif Ersoy Ortaokulu",
//   "NEVŞEHİR - AVANOS - Kalaba Kazım Karabekir Ortaokulu",
//   "NEVŞEHİR - AVANOS - Çalış Ortaokulu",
//   "NEVŞEHİR - AVANOS - Ayhanlar Ortaokulu",
//   "NEVŞEHİR - AVANOS - Avanos Mehmet Akif Ersoy Ortaokulu",
//   "NEVŞEHİR - AVANOS - Avanos İmam Hatip Ortaokulu",
//   "NEVŞEHİR - AVANOS - Akarca Ortaokulu",
//   "NEVŞEHİR - AVANOS - Ahmet Ergün Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Topaç Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Tepeköy Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Tatlarin Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Tatlarin İmam Hatip Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Kurugöl 70.Yıl Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Karapınar İmam Hatip Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Karacaören Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Karacaören Cumhuriyet Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - İnallı Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Ağıllı Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Acıgöl Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Acıgöl İmam Hatip Ortaokulu",
//   "NEVŞEHİR - ACIGÖL - Acıgöl 4 Temmuz Ortaokulu",
//   "NEVŞEHİR - Özel Altınyıldız Koleji Ortaokulu",
//   "NEVŞEHİR - Özel Kardelen Koleji Ortaokulu",
//   "NEVŞEHİR - Özel Simya Koleji Ortaokulu",
//   "NEVŞEHİR - Özel MBA Okulları Ortaokulu"
// ];

// const ApplicationForm = () => {
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     phone: '',
//     school: '',
//     grade: ''
//   });

//   const [schoolSearch, setSchoolSearch] = useState('');
//   const [showDropdown, setShowDropdown] = useState(false);

//   const dropdownRef = useRef(null);

//   const filteredSchools = schools.filter(s =>
//     s.toLowerCase().includes(schoolSearch.toLowerCase())
//   );

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === 'phone') {
//       const num = value.replace(/[^\d]/g, '');
//       const noZero = num.startsWith("0") ? num.slice(1) : num;
//       let t = noZero.slice(0, 10);

//       let f = "";
//       if (t.length > 0) f = "(" + t.slice(0, 3);
//       if (t.length >= 3) f += ") " + t.slice(3, 6);
//       if (t.length >= 6) f += "-" + t.slice(6, 10);

//       setFormData(prev => ({ ...prev, phone: f }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   const validatePhoneNumber = (phone) => {
//     const n = phone.replace(/[^\d]/g, '');
//     const ops = [
//       '501','505','506','507','551','552','553','554','555','559',
//       '530','531','532','533','534','535','536','537','538','539',
//       '540','541','542','543','544','545','546','547','548','549'
//     ];
//     return n.length === 10 && ops.includes(n.slice(0, 3));
//   };

// const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Telefon numarası kontrolü
//     if (!validatePhoneNumber(formData.phone)) {
//       alert('Lütfen geçerli bir Türkiye GSM numarası giriniz.\nÖrnek: (5XX) XXX-XXXX');
//       return;
//     }

//     try {
//       // Firestore'a başvuruyu kaydet
//       await addDoc(collection(db, 'applications'), {
//         ...formData,
//         submittedAt: new Date()
//       });

//       // VatanSMS API bilgileri (.env dosyasından geliyor)
//       const VATAN_API_ID = process.env.REACT_APP_VATAN_API_ID;
//       const VATAN_API_KEY = process.env.REACT_APP_VATAN_API_KEY;
//       const VATAN_SENDER = process.env.REACT_APP_VATAN_SENDER;

//       // SMS gönder (bilgiler tanımlıysa)
//       if (VATAN_API_ID && VATAN_API_KEY && VATAN_SENDER) {
//         const smsResult = await sendApplicationConfirmationSMS({
//           apiId: VATAN_API_ID,
//           apiKey: VATAN_API_KEY,
//           sender: VATAN_SENDER,
//           phone: formData.phone,
//           firstName: formData.firstName,
//         });

//         console.log("VatanSMS sonucu:", smsResult);
//       } else {
//         console.warn("VatanSMS .env bilgileri tanımlı değil, SMS gönderilmedi.");
//       }

//       alert('Başvurunuz başarıyla gönderildi!');
//       setFormData({
//         firstName: '',
//         lastName: '',
//         phone: '',
//         school: '',
//         grade: ''
//       });
//     } catch (error) {
//       console.error('Error submitting application:', error);
//       alert('Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
//     }
//   };

//   return (
//     <div className="application-form">
//       <div className="banner-container">
//         <div className="banner-image"></div>
//       </div>

//       <div className="form-content">
//         <h1>Akademi Bursluluk Başvurusu</h1>

//         <form onSubmit={handleSubmit}>

//           <div className="form-group">
//             <label>Ad</label>
//             <input name="firstName" value={formData.firstName} onChange={handleChange} required />
//           </div>

//           <div className="form-group">
//             <label>Soyad</label>
//             <input name="lastName" value={formData.lastName} onChange={handleChange} required />
//           </div>

//           <div className="form-group">
//             <label>Telefon (5XX) XXX-XXXX</label>
//             <input name="phone" value={formData.phone} onChange={handleChange} required />
//           </div>

//           {/* ÖZEL OKUL DROPDOWN */}
//           <div className="form-group" ref={dropdownRef}>
//             <label>Okul</label>

//             <div className="dropdown-input" onClick={() => setShowDropdown(true)}>
//               <input
//                 type="text"
//                 placeholder="Okul ara..."
//                 value={schoolSearch}
//                 onChange={(e) => {
//                   setSchoolSearch(e.target.value);
//                   setShowDropdown(true);
//                 }}
//               />
//             </div>

//             {showDropdown && (
//               <div className="dropdown-menu">
//                 {filteredSchools.length === 0 ? (
//                   <div className="dropdown-item disabled">Sonuç bulunamadı</div>
//                 ) : (
//                   filteredSchools.map((school, i) => (
//                     <div
//                       key={i}
//                       className="dropdown-item"
//                       onClick={() => {
//                         setFormData(prev => ({ ...prev, school }));
//                         setSchoolSearch(school);
//                         setShowDropdown(false);
//                       }}
//                     >
//                       {school}
//                     </div>
//                   ))
//                 )}
//               </div>
//             )}
//           </div>

//           <div className="form-group">
//             <label>Sınıf</label>
//             <select
//               name="grade"
//               value={formData.grade}
//               onChange={handleChange}
//               required
//             >
//               <option value="">Sınıf Seçiniz</option>
//               <option value="6">6. Sınıf</option>
//               <option value="7">7. Sınıf</option>
//             </select>
//           </div>

//           <button type="submit">Başvuruyu Gönder</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ApplicationForm;




// /* BİLGİLENDİRME MESAJI KODU - İHTİYAÇ DURUMUNDA KULLANMAK İÇİN YEDEK
import React from 'react';
import './ApplicationForm.css';

const ApplicationForm = () => {
  return (
    <div className="application-form">
      <div className="banner-container">
        <div className="banner-image"></div>
      </div>
      <div className="info-message">
        <h1>Akademi Bursluluk Başvurusu</h1>
        <p>Başvuru süresi dolmuştur.</p>
        <p>Bu konu hakkında bilgi almak için</p>
        <p className="phone-number">+90 533 133 95 48</p>
        <p>numarası ile iletişime geçin.</p>
      </div>
    </div>
  );
};

export default ApplicationForm;
